import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function claimReducer (state=initialState.claim, action) {
    switch (action.type) {
        case types.CLAIM__REPORT_REQUEST:
            return {...state, loading: true};
        case types.CLAIM__REPORT_FAILURE:
            return {...state, loading: false};
        case types.CLAIM__UPDATE_CLAIM:
            return {...state, ...action.claim};
        case types.CLAIM__REPORT_SUCCESS:
        case types.CLAIM__RESET_CLAIM:
            return {...initialState.claim};
        default:
            return state;
    }
}
